<template>
  <div class="text-cta" @click="openRefixationPopup">
    <div>
      REFIX
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplicationRefixationHandler",
  props: {
    mortgage: Object
  },
  methods: {
    openRefixationPopup () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: "",
        payload: this.mortgage,
        component: "ApplicationRefixationPopUp",
        rules: ['priority'],
      })
    },
  },
}
</script>

<style scoped>

</style>